module.exports = __webpack_public_path__ + "static/media/udemy-icon.f2affa1f.svg";